var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPain910(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pain9-10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UCC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Urgent-Care-Pain-Scale",
    transform: "translate(-2271.000000, -770.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9-10-Pain",
    transform: "translate(2271.000000, 770.000000)",
    stroke: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 7,
    fill: "#7BE700",
    cx: 100,
    cy: 100,
    r: 96.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2222222,115.555556 C62.5221887,162.158626 137.777778,161.943815 137.777778,115.555556 C137.777778,115.555556 112.592593,115.555556 62.2222222,115.555556 Z",
    id: "Path-3",
    strokeWidth: 8,
    transform: "translate(100.000000, 132.991453) scale(-1, -1) translate(-100.000000, -132.991453) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(53.333333, 75.555556)",
    strokeLinecap: "round",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "0 0 26.6666667 14.1617934 0 26.6666667"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    transform: "translate(80.000000, 13.333333) scale(-1, 1) translate(-80.000000, -13.333333) ",
    points: "66.6666667 0 93.3333333 14.1617934 66.6666667 26.6666667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(129.000000, 717.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 2047,
    y: 4,
    width: 390,
    height: 696,
    rx: 60
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPain910);
export default __webpack_public_path__ + "static/media/pain9-10.83e1b3a1e4c3b7d22787a49531370b77.svg";
export { ForwardRef as ReactComponent };